import { Action, Reducer } from 'redux';
import {
  SupplierInventoryImportStatusState,
  SupplierInventoryImportStatusTypes,
  SupplierInventoryImportStatusActionTypes
} from './supplierInventoryImportStatusTypes';

export const INITIAL_STATE: SupplierInventoryImportStatusState = {
  supplierInventoryImportStatus: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const supplierInventoryImportStatusReducer: Reducer<SupplierInventoryImportStatusState> = (
  state: SupplierInventoryImportStatusState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as SupplierInventoryImportStatusActionTypes;
  switch (actionTypes.type) {
    case SupplierInventoryImportStatusTypes.GET_SUPPLIER_INVENTORY_IMPORT_STATUS:
      return {
        ...state,
        supplierInventoryImportStatus: { ...state.supplierInventoryImportStatus, isLoading: true }
      };
    case SupplierInventoryImportStatusTypes.SAVE_SUPPLIER_INVENTORY_IMPORT_STATUS:
      return {
        ...state,
        supplierInventoryImportStatus: {
          ...state.supplierInventoryImportStatus,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case SupplierInventoryImportStatusTypes.RESET_REDUCER_SUPPLIER_INVENTORY_IMPORT_STATUS:
      return {
        ...state,
        supplierInventoryImportStatus: INITIAL_STATE.supplierInventoryImportStatus
      };
    default:
      return state;
  }
};

export default supplierInventoryImportStatusReducer;
